import { motion } from "framer-motion";

export default function SectionLabel({ number, label }) {
  return (
    <motion.div
      initial={{ opacity: 0, x: -16 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      className="flex items-center gap-3 mb-8"
    >
      <span className="font-mono text-[#d4af37] text-xs tracking-widest">
        {number}
      </span>
      <span className="h-px w-12 bg-[#d4af37]/50" />
      <span className="overline">{label}</span>
    </motion.div>
  );
}
